import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import ExplorerDashboard from "@/pages/ExplorerDashboard";
import CouncilDashboard from "@/pages/CouncilDashboard";
import AdminPortal from "@/pages/AdminPortal";
import ExpertDiscovery from "@/pages/ExpertDiscovery";
import ExpertProfile from "@/pages/ExpertProfile";
import BookingFlow from "@/pages/BookingFlow";
import KnowledgeHub from "@/pages/KnowledgeHub";
import AcceptInvitation from "@/pages/AcceptInvitation";

function AppRouter() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const location = useLocation(); // read hash from here, not window.location.hash (not reactive)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/accept-invitation/:token" element={<AcceptInvitation />} />
      <Route path="/discover" element={<ProtectedRoute><ExpertDiscovery /></ProtectedRoute>} />
      <Route path="/expert/:userId" element={<ProtectedRoute><ExpertProfile /></ProtectedRoute>} />
      <Route path="/knowledge" element={<ProtectedRoute><KnowledgeHub /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute role="explorer"><ExplorerDashboard /></ProtectedRoute>} />
      <Route path="/council" element={<ProtectedRoute role="council_member"><CouncilDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminPortal /></ProtectedRoute>} />
      <Route path="/book/:serviceId" element={<ProtectedRoute role="explorer"><BookingFlow /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="bottom-right" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
